if ("production" !== process.env.NODE_ENV) {
    console.warn("[mobx-react-lite] importing batchingOptOut is no longer needed")
}
